import { Component, OnInit } from '@angular/core';
import {HttpService} from "../../services/http.service";
import {Router} from "@angular/router";
import {UserDataStoreService} from "../../services/user-data-store.service";

@Component({
  selector: 'app-otp',
  templateUrl: './otp.component.html',
  styleUrls: ['./otp.component.scss']
})
export class OtpComponent  {

  otpCode: string = '';
  errorMessage: string = '';
  isSubmitting = false;

  constructor(
    private http: HttpService,
    private router: Router,
    private userStore: UserDataStoreService
  ) {}

  async submitOtp() {
    this.isSubmitting = true;
    this.errorMessage = '';

    const userId = sessionStorage.getItem('2fa_user_id');

    if (!userId) {
      this.errorMessage = 'Session expired. Please login again.';
      return;
    }
debugger;
    try {
      const result = await this.http.apiPost<any>('authentication/verify-otp', {
        userId,
        otpCode: this.otpCode
      });
debugger;
      if (result && result.body) {
        this.userStore.UpdateUser(result.body);
        sessionStorage.removeItem('2fa_user_id');
        this.router.navigate(['/']);
      } else {
        this.errorMessage = 'Invalid OTP code.';
      }
    } catch (err) {
      this.errorMessage = 'Failed to verify OTP.';
    }

    this.isSubmitting = false;
  }

}
